export default __webpack_public_path__ + "static/media/chevronLeft.ea7ace88.svg";